module.exports = __webpack_public_path__ + "static/blog79-c23eb1b2dd990f4d727d9a3023a89e67.png";